module.exports = __webpack_public_path__ + "static/media/ANALISIS CAME PERSONAL PARA LA EMPLEABILIDAD.88b5d2b2.xlsx";